import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "@/shared/lib/cn";

// Accessible toggle switch (now Radix-backed; Space/Enter + role/aria handled for free).
// External API is UNCHANGED from the hand-rolled version: `onChange` is a no-arg toggle —
// Radix's onCheckedChange(next: boolean) is wider, so passing it through is safe (arg ignored).
// Label via aria-label or aria-labelledby.
interface SwitchProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  "aria-label"?: string;
  "aria-labelledby"?: string;
}

export function Switch({ checked, onChange, disabled, ...aria }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      checked={checked}
      onCheckedChange={onChange}
      disabled={disabled}
      {...aria}
      className={cn(
        "relative inline-flex h-6 w-11 flex-none items-center rounded-pill outline-none transition-colors",
        "focus-visible:ring-2 focus-visible:ring-green/40 focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=checked]:bg-green data-[state=unchecked]:bg-grey-300",
      )}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          "inline-block h-5 w-5 transform rounded-pill bg-white shadow-sm transition-transform",
          "data-[state=checked]:translate-x-[22px] data-[state=unchecked]:translate-x-[2px]",
        )}
      />
    </SwitchPrimitive.Root>
  );
}
